/**
 * Phone number utility functions
 * Provides normalization and formatting for phone numbers
 */

/**
 * Normalize phone number to 10 digits
 * @param {string} raw - Raw phone number input
 * @returns {string} Normalized 10-digit phone number
 */
export function normalizePhone(raw) {
  if (!raw) return "";
  const digits = raw.replace(/\D/g, "");
  return digits.length === 11 && digits.startsWith("1")
    ? digits.substring(1)
    : digits;
}

/**
 * Format 10-digit phone number to (XXX) XXX-XXXX
 * @param {string} num - 10-digit phone number
 * @returns {string} Formatted phone number or original if invalid
 */
export function formatPhone(num) {
  if (!num) return num;

  // If we get E.164 (+1XXXXXXXXXX), strip +1 for display
  const digits = num.replace(/\D/g, "");
  const local10 =
    digits.length === 11 && digits.startsWith("1")
      ? digits.substring(1)
      : digits.length === 10
      ? digits
      : null;

  if (!local10) return num; // fallback to raw if not a 10/11-digit US number

  return `(${local10.slice(0, 3)}) ${local10.slice(3, 6)}-${local10.slice(6)}`;
}
